<template>
  <div>
    <titulo-depositos @cadastrar="openModal" />

    <tabela-deposito
      :items="depositos"
      @atualiza-tabela="getDepositos"
      @editar="openModal"
      @alterar-ordenacao="novaOrdenacao"
    />

    <paginacao
      v-model="paginacao"
      :total="paginacao.total"
      @input="getDepositos"
    />

    <modal-formulario-deposito
      :exibir="modais.deposito"
      :dados="modais.depositoDados"
      @atualiza-tabela="getDepositos"
      @fechar="closeModal"
    />
  </div>
</template>
<script>
// Utils & Aux:
import breadcrumb from '@/common/utils/breadcrumb';
import { START_LOADING, STOP_LOADING } from '@/store/Store';
import mensagem from '@/common/utils/mensagem';
import modais from '@/common/utils/modais';
// Services:
import DepositosService from '@/common/services/depositos/depositos.service.js';

// Components:
import TabelaDeposito from './components/Tabela';
import ModalFormularioDeposito from './components/ModalFormularioDeposito';

import TituloDepositos from '@/views/suprimentos/depositos/components/TituloDepositos';
import Paginacao from '@/components/paginacao/Paginacao';

export default {
  components: {
    TituloDepositos,
    TabelaDeposito,
    ModalFormularioDeposito,
    Paginacao,
  },
  data() {
    return {
      depositos: [],
      modais: {
        deposito: false,
        depositoDados: {},
      },
      paginacao: {
        numeroDaPagina: 1,
        tamanhoDaPagina: 10,
        total: 0,
      },
      campoOrdenado: null,
      ordem: false,
    };
  },
  mounted() {
    breadcrumb.definir(this.$store, [
      { titulo: 'SUPRIMENTOS.SUPRIMENTOS' },
      { titulo: 'SUPRIMENTOS.DEPOSITOS' },
    ]);
    this.getDepositos();
  },
  methods: {
    getDepositos() {
      let param = {
        NumeroDaPagina: this.paginacao.numeroDaPagina,
        TamanhoDaPagina: this.paginacao.tamanhoDaPagina,
        CampoOrdenado : this.campoOrdenado, 
        OrdenacaoAscendente: this.ordem,
      }

      this.$store.dispatch(START_LOADING);
      DepositosService.obterTodos(param)
        .then(({data}) => {
          this.depositos = data.itens;
          this.paginacao.total = data.paginacao.totalDeElementos;
        })
        .catch((err) => {
          mensagem.showErrors(err);
        })
        .finally(() => {
          this.$store.dispatch(STOP_LOADING);
        });
    },
    // FUNÇÕES MODAL:
    openModal(key, item = {}) {
      if (item?.id) {
        DepositosService.obterDeposito(item.id).then(({ data }) => {
          return modais.abrirModal(this, key, data);
        })
      }
      
      return modais.abrirModal(this, key, item);
    },
    closeModal(key) {
      return modais.fecharModal(this, key);
    },
    
    novaOrdenacao(campoOrdenado, ordem) {
      this.campoOrdenado = campoOrdenado;
      this.ordem = !ordem;
      this.getDepositos(); 
    },
  },
};
</script>
